import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  DATA_START_ROW,
  HEADER_FILL,
  HEADER_ROW,
  TABLE_HEADER_FILL,
  TITLE_ROW,
} from "./principle1DetailHelpers";

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const SHEET_TITLE =
  "Awareness programmes conducted for value chain partners on any of the Principles during the financial year";

const HEADERS = [
  { col: COL_D, label: "Sr. No.", width: 8 },
  { col: COL_E, label: "Total number of awareness programmes held", width: 18 },
  {
    col: COL_F,
    label: "Topics / principles covered under the training",
    width: 36,
  },
  {
    col: COL_G,
    label:
      "Percentage of value chain partners covered (by value of business done with such partners) under the awareness programmes",
    width: 24,
  },
];

export const SHEET_NAME = "Programmes for value chain";

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: options.vertical || "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function topicsText(value) {
  if (Array.isArray(value)) {
    const filtered = value.filter(
      (item) => String(item).trim().toLowerCase() !== "select all"
    );
    return filtered.length ? filtered.join(", ") : "-";
  }
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function formatPercent(value) {
  if (value === null || value === undefined || value === "") return "-";
  const str = String(value);
  return str.includes("%") ? str : `${str}%`;
}

function setColumnWidths(ws) {
  const widths = { A: 2, B: 2, C: 2 };
  HEADERS.forEach(({ col, width }) => {
    widths[String.fromCharCode(64 + col)] = width;
  });
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
}

export function buildProgrammesForValueChainSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setColumnWidths(ws);
  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_1, { mergeEnd: COL_G });

  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_G);
  setCell(ws, TITLE_ROW, COL_D, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  HEADERS.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      bold: true,
      fill: TABLE_HEADER_FILL,
      align: "center",
    });
  });

  const programs = Array.isArray(sectionC?.principle1?.leadershipIndicator?.awarenessProgram)
    ? sectionC.principle1.leadershipIndicator.awarenessProgram
    : [];
  const rows = programs.length ? programs : [{}];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, item?.totalProgram ?? "-", { align: "center" });
    setCell(ws, row, COL_F, topicsText(item?.topicsPrinciples), {
      align: "left",
      vertical: "top",
    });
    setCell(ws, row, COL_G, formatPercent(item?.percentage), { align: "center" });
    ws.getRow(row).height = Math.max(18, Math.ceil(topicsText(item?.topicsPrinciples).length / 40) * 15);
  });

  return ws;
}
